import { invokeApi } from "../../utils/invokeApi/invokeApi";

// Get blogs by category slug with search and pagination
export const get_blogs_by_category_slug_api = async (
  category_slug,
  search = "",
  page = 1,
  limit = 100
) => {
  const requestObj = {
    path: `api/blog/get_blog_by_category_slug/${category_slug}?search=${encodeURIComponent(
      search
    )}&page=${page}&limit=${limit}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
export const get_blogs_listing = async (
  source_slug,
  feature_slug,
  search = "",
  category_slug = "",
  client_id = "",
  page = 0,
  limit = 20
) => {
  const requestObj = {
    path: `api/blog/get_blog_for_client?source_slug=${source_slug}&feature_slug=${feature_slug}&search=${encodeURIComponent(
      search
    )}&page=${page}&limit=${limit}&category_slug=${category_slug}&client_id=${client_id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const get_Active_Categories_by_feature_slug = async (
  spurce_slug = "",
  featureSlug = "",
  page = 0,
  limmit = 100,
  search = ""
) => {
  const requestObj = {
    path: `api/category/active_category_by_feature_slug/${featureSlug}?limit=${limmit}&page=${page}&search=${search}&source_slug=${spurce_slug}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const add_blog = async (data) => {
  const requestObj = {
    path: `api/blog/add_blog`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const update_blog = async (slug, data) => {
  const requestObj = {
    path: `api/blog/update_blog/${slug}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const details_blog = async (slug) => {
  const requestObj = {
    path: `api/blog/detail_blog/${slug}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const delete_blog = async (id) => {
  const requestObj = {
    path: `api/blog/delete_blog/${id}`,
    method: "DELETE",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const blog_view_count_increase = async (id) => {
  const requestObj = {
    path: `api/blog/view_count/${id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
